import { urlUtils } from '@festina-life/core'

/**
 * Serialises a typed configuration entity and hands it to the browser as a JSON
 * document, so that every JSON export in the portal produces the same kind of file.
 */
export const downloadJsonFile = (data: { _type: string }, fileName: string) => {
  const jsonBlob = new Blob([JSON.stringify(data)], {
    type: 'application/json',
  })

  urlUtils.downloadAsFile(jsonBlob, fileName)
}
